import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  INewDayOffOverride,
  INewUser,
  IUpdateUserProfile,
  IUser,
  IUserAssign,
  IUserDayOff,
  IUserFilter,
  IWorkerFilter,
  IDayOffOverride,
} from "@/features/users/user.types";
import { cleanParams } from "@/utils/cleanParams";

export const userService = {
  getUsers(filter: IUserFilter): Promise<AxiosResponse> {
    return http.get<IUser[]>("/users/", {
      params: cleanParams(filter),
    });
  },

  createUser(payload: INewUser): Promise<AxiosResponse> {
    return http.post("/users/", payload);
  },

  getWorkers(filter: IWorkerFilter): Promise<AxiosResponse> {
    return http.get<IUser[]>("/users/workers", {
      params: cleanParams(filter),
    });
  },

  getUserById(userId: string): Promise<AxiosResponse> {
    return http.get<IUser>(`/users/${userId}`);
  },

  deactivateUser(userId: string): Promise<AxiosResponse> {
    return http.delete(`/users/${userId}`);
  },

  updateUserProfile(
    userId: string,
    payload: IUpdateUserProfile
  ): Promise<AxiosResponse> {
    return http.patch(`/users/${userId}/profile`, payload);
  },

  assignUser(userId: string, payload: IUserAssign): Promise<AxiosResponse> {
    return http.patch(`/users/${userId}/assignment`, payload);
  },

  updateDayOff(userId: string, payload: IUserDayOff): Promise<AxiosResponse> {
    return http.patch(`/users/${userId}/day-off`, payload);
  },

  getDayOffOverrides(userId: string): Promise<AxiosResponse> {
    return http.get<IDayOffOverride[]>(`/users/${userId}/day-off-overrides`);
  },

  createOrUpdateDayOffOverride(
    userId: string,
    payload: INewDayOffOverride
  ): Promise<AxiosResponse> {
    return http.post(`/users/${userId}/day-off-overrides`, payload);
  },

  deleteDayOffOverride(
    userId: string,
    overrideId: string
  ): Promise<AxiosResponse> {
    return http.delete(`/users/${userId}/day-off-overrides/${overrideId}`);
  },

  getEffectiveDayOff(
    userId: string,
    target_date: string
  ): Promise<AxiosResponse> {
    return http.get(
      `/users/${userId}/effective-day-off?target_date=${target_date}`
    );
  },

  getUserAvailability(
    userId: string,
    target_date: string
  ): Promise<AxiosResponse> {
    return http.get(`/users/${userId}/availability?target_date=${target_date}`);
  },

  getUserProfile(): Promise<AxiosResponse> {
    return http.get("/users/profile");
  },

  updatePassword(userId: string, payload: any): Promise<AxiosResponse> {
    return http.patch(`/users/${userId}/password`, payload);
  },
};
